import React, { useEffect } from "react";
import { InputCheck } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { Collapse } from "@mui/material";

const PaymentMethodAccess = ({ setFeaturesAccess, featuresAccess }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!featuresAccess.id) {
      featuresAccess.isHavePaymentMethodAccess
        ? setFeaturesAccess((j) => ({
            ...j,
            paymentMethod: {
              isHaveAddAccess: true,
              isHaveExportAccess: true,
              isHaveEditAccess: true,
              isHaveDeleteAccess: true,
            },
          }))
        : setFeaturesAccess((j) => ({
            ...j,
            paymentMethod: {
              isHaveAddAccess: false,
              isHaveExportAccess: false,
              isHaveEditAccess: false,
              isHaveDeleteAccess: false,
            },
          }));
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresAccess.isHavePaymentMethodAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setFeaturesAccess((j) => ({
      ...j,
      paymentMethod: { ...j.paymentMethod, [name]: checked },
    }));
  };

  return (
    <Collapse in={featuresAccess.isHavePaymentMethodAccess || false}>
      <div className="ml-25 d-grid g-5 mt-5">
        <InputCheck
          label={t("isHaveAddAccess")}
          checked={
            (featuresAccess.paymentMethod &&
              featuresAccess.paymentMethod.isHaveAddAccess) ||
            false
          }
          name={"isHaveAddAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveExportAccess")}
          checked={
            (featuresAccess.paymentMethod &&
              featuresAccess.paymentMethod.isHaveExportAccess) ||
            false
          }
          name={"isHaveExportAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveEditAccess")}
          checked={
            (featuresAccess.paymentMethod &&
              featuresAccess.paymentMethod.isHaveEditAccess) ||
            false
          }
          name={"isHaveEditAccess"}
          onClick={handleInpChg}
        />
        <InputCheck
          label={t("isHaveDeleteAccess")}
          checked={
            (featuresAccess.paymentMethod &&
              featuresAccess.paymentMethod.isHaveDeleteAccess) ||
            false
          }
          name={"isHaveDeleteAccess"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default PaymentMethodAccess;
